module.exports = __webpack_public_path__ + "img/lines-none.73caa172.svg";